/* ------------------------------------------------------------------
   گفتگو ⟵ قالبِ پنل
   ------------------------------------------------------------------
   🔴 در گوشی نوارِ بالای پنل در صفحهٔ گفتگو پنهان است — مثلِ واتساپ و
   تلگرام فقط یک نوار می‌ماند، نوارِ خودِ گفتگو. «≡» ِ آن نوار از قاب
   `{carbon:'open-nav'}` می‌فرستد و `ChatFrameHost` همین رخداد را روی
   window می‌اندازد تا `AppShell` منوی پنل را باز کند.
   ------------------------------------------------------------------ */

export const OPEN_NAV_EVENT = 'pf:chat-open-nav'

/* ------------------------------------------------------------------
   عکسِ نمایهٔ گفتگو عوض شد (۱۴۰۵/۰۸/۱۱)
   ------------------------------------------------------------------
   🔴 «عکسِ چت همه‌جا»: پس از `me.photoChanged` (`rpc/methods.ts`) عکسِ
   نوارِ بالا، دفترچه و چارت باید همان لحظه عوض شوند، نه با بارگذاریِ
   دوباره. `AuthProvider` این رخداد را می‌شنود: پروفایل را از نو می‌خواند و
   فهرست‌های آدم‌ها را کهنه اعلام می‌کند.
   ------------------------------------------------------------------ */

export const PROFILE_PHOTO_EVENT = 'pf:profile-photo-changed'
